import Breadcrumb from 'components/Navigation/Breadcrumb';
import React, { useState } from 'react';
import male from '../../../../../assets/male-big.png';
import company from '../../../../../assets/company-2.png';
import Button from 'components/Form/Button';
import { Icon, Icons } from 'components/Icon';
import BankBeneficiaryAssets from './AssetsTypes/BankBeneficiaryAssets';
import BondsBeneficiaryAssets from './AssetsTypes/BondsBeneficiaryAssets';
import StocksBeneficiaryAssets from './AssetsTypes/StocksBeneficiaryAssets';
import EmployeeBenefitAssets from './AssetsTypes/EmployeeBenefitBeneficiaryAssets';
import { useParams } from 'react-router-dom';
import { useGetBeneficiaryDetails } from 'common/queries-and-mutations/beneficiary';
import { Loader } from 'components/Loader';
import EditBeneficiaryModal from './EditBeneficiaryModal';
import { BeneficiaryTypeEnum } from 'apps/user/types/user.enum.type';
import { format } from 'date-fns';
import PhysicalBeneficiaryAsset from './AssetsTypes/PhysicalBeneficiaryAsset';
import RSABeneficiaryAssets from './AssetsTypes/RSABeneficiaryAssets';
import withCreatePortal from 'components/HOC/withCreatePortal';

const EnhancedEditBeneficiaryForm = withCreatePortal(EditBeneficiaryModal);

export default function BeneficiaryProfile() {
  const [showEditModal, setShowEditModal] = useState(false);
  const [userId, setUserId] = useState<number | null | undefined>(null);

  const { beneficiaryId } = useParams();

  const { data, isLoading, refetch } = useGetBeneficiaryDetails({
    beneficiaryId: Number(beneficiaryId)
  });

  return (
    <div>
      {isLoading && data ? (
        <div className="mt-40 flex flex-col items-center justify-center">
          <Loader color={'#FF6606'} height={50} width={50} />
        </div>
      ) : (
        <>
          <Breadcrumb title="Beneficiary Profile" />
          <div className="mt-1">
            <div className="mb-5 flex flex-row rounded bg-white">
              <div className="flex w-1/5 flex-col items-center justify-center border-r px-6">
                <div className="flex flex-col items-center justify-center gap-3">
                  <img
                    src={
                      data?.beneficiaryType === BeneficiaryTypeEnum.CORPORATE
                        ? company
                        : male
                    }
                    className="h-32 w-32"
                  />
                  <p className="text-center text-lg font-bold text-[#353535]">
                    {`${data?.beneficiaryFirstName} ${data?.beneficiaryMiddleName} ${data?.beneficiaryLastName}`}
                  </p>
                </div>
              </div>
              <div className="w-full">
                <div className="border-b border-[#E5E5E5]">
                  <div className="mt-3 grid grid-cols-4 gap-x-16 px-6">
                    <div className="col-span-1 px-8 py-6">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Name
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {`${data?.beneficiaryFirstName} ${data?.beneficiaryMiddleName} ${data?.beneficiaryLastName}`}
                      </p>
                    </div>
                    <div className="col-span-1 px-8 py-6">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Type
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.beneficiaryType}
                      </p>
                    </div>
                    <div className="col-span-1 px-8 py-4">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Email address
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.emailAddress}
                      </p>
                    </div>
                    {data?.beneficiaryType ===
                      BeneficiaryTypeEnum.INDIVIDUAL && (
                      <div className="col-span-1 px-8 py-6">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          Date of Birth
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data?.dateOfBirth && data.dateOfBirth !== ''
                            ? format(new Date(data.dateOfBirth), 'dd MMMM yyyy')
                            : 'Unknown'}
                        </p>
                      </div>
                    )}
                    {data?.beneficiaryType ===
                      BeneficiaryTypeEnum.CORPORATE && (
                      <div className="col-span-1 px-8 py-6">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          Incorporation Date
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data && data.incorporationDate !== ''
                            ? format(
                                new Date(data.incorporationDate),
                                'dd MMMM yyyy'
                              )
                            : 'Unknown'}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="border-b border-[#E5E5E5]">
                  <div className="grid grid-cols-4 gap-x-16 px-6">
                    {data?.beneficiaryType ===
                      BeneficiaryTypeEnum.CORPORATE && (
                      <div className="col-span-1 px-8 py-6">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          Incorporation Place
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data?.incorporationPlace || 'Unknown'}
                        </p>
                      </div>
                    )}
                    {data?.beneficiaryType ===
                      BeneficiaryTypeEnum.INDIVIDUAL && (
                      <div className="col-span-1 px-8 py-6">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          Relationship
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data?.relationship || 'Unknown'}
                        </p>
                      </div>
                    )}
                    {data?.beneficiaryType ===
                      BeneficiaryTypeEnum.CORPORATE && (
                      <div className="col-span-1 px-8 py-6">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          Rc Number
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data?.rcNumber || 'Unknown'}
                        </p>
                      </div>
                    )}
                    {data?.beneficiaryType ===
                      BeneficiaryTypeEnum.INDIVIDUAL && (
                      <div className="col-span-1 px-8 py-6">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          Marital Status
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data?.maritalStatus || 'Unknown'}
                        </p>
                      </div>
                    )}
                    <div className="col-span-1 px-8 py-4">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Address
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.address || 'Unknown'}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-4 gap-x-16 px-6">
                  <div className="col-span-1 px-8 py-4">
                    <Button
                      variant="outline"
                      size="md"
                      className="w-[15rem] rounded border border-[#FF7A00] bg-[#FFF8F2] p-[0.1rem] text-[#FF7A00]"
                      label="Edit Beneficiary"
                      icon={<Icon name={Icons.Edit} />}
                      onClick={() => {
                        setUserId(data?.id);
                        setShowEditModal(true);
                      }}
                    ></Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <p className="text-base text-[#7A7C87]">Assigned Assets</p>
              {!data?.isAssigned ? (
                <div className="mt-10">
                  <p className="text-center font-circular text-lg font-bold">
                    No asset assigned
                  </p>
                </div>
              ) : (
                <div className="mt-2 h-[550px] overflow-auto scrollbar-hide">
                  {data.bankAllocations.length > 0 && (
                    <BankBeneficiaryAssets
                      assets={data?.bankAllocations}
                      onSuccess={refetch}
                    />
                  )}
                  {data.stockShareAllocations.length > 0 && (
                    <StocksBeneficiaryAssets
                      assets={data.stockShareAllocations}
                      onSuccess={refetch}
                    />
                  )}
                  {data.bondAllocations.length > 0 && (
                    <BondsBeneficiaryAssets
                      assets={data.bondAllocations}
                      onSuccess={refetch}
                    />
                  )}
                  {data.physicalAssetAllocations.length > 0 && (
                    <PhysicalBeneficiaryAsset
                      assets={data.physicalAssetAllocations}
                      onSuccess={refetch}
                    />
                  )}
                  {data.employerAllocations.length > 0 && (
                    <EmployeeBenefitAssets
                      assets={data.employerAllocations}
                      onSuccess={refetch}
                    />
                  )}
                  {data.pensionAccountAllocations.length > 0 && (
                    <RSABeneficiaryAssets
                      assets={data.pensionAccountAllocations}
                      onSuccess={refetch}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </>
      )}
      {showEditModal && userId && (
        <EnhancedEditBeneficiaryForm
          onClose={() => {
            setShowEditModal(false);
            refetch();
          }}
          onSuccess={() => {
            refetch();
            setShowEditModal(false);
            setUserId(null);
          }}
          beneficiaryId={userId}
        />
      )}
    </div>
  );
}
